export type DesktopTheme = 'teal' | 'navy' | 'plum';

const THEME_KEY = 'ivansivak-workstation-theme';
const SCALE_KEY = 'ivansivak-workstation-scale';
const GRID_KEY = 'ivansivak-workstation-grid';

export interface WorkstationPreferences {
  theme: DesktopTheme;
  scale: number;
  grid: boolean;
}

function safeGet(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Preferences are optional; private browsing or policy may disable storage.
  }
}

export function readPreferences(): WorkstationPreferences {
  const rawTheme = safeGet(THEME_KEY);
  const theme: DesktopTheme = rawTheme === 'navy' || rawTheme === 'plum' ? rawTheme : 'teal';
  const rawScale = Number(safeGet(SCALE_KEY));
  const scale = Number.isFinite(rawScale) && rawScale >= 0.85 && rawScale <= 1.2 ? rawScale : 1;
  const grid = safeGet(GRID_KEY) !== 'off';
  return { theme, scale, grid };
}

export function applyPreferences(preferences: WorkstationPreferences): void {
  document.documentElement.dataset.theme = preferences.theme;
  document.documentElement.dataset.grid = preferences.grid ? 'on' : 'off';
  document.documentElement.style.setProperty('--workstation-scale', String(preferences.scale));
}

export function savePreferences(preferences: WorkstationPreferences): void {
  safeSet(THEME_KEY, preferences.theme);
  safeSet(SCALE_KEY, String(preferences.scale));
  safeSet(GRID_KEY, preferences.grid ? 'on' : 'off');
  applyPreferences(preferences);
}
